// extracted by mini-css-extract-plugin
module.exports = {"container":"Columns_container__Nmv5R","containerWide":"Columns_containerWide__1eiTy"};